<template>
  <div style="min-height: 100vh;">
    <div class="is-size-7 p-md">
      <div class="has-text-centered" style="margin:auto;max-width:600px;">
        <div class="g-tile">
        <div class="g-tile-top has-background-primary has-text-primary">
          <router-link :to="{ name: 'Home' }">
            <img src="@/../static/gamega.me/logo_black.png" class="is-inline-block p-md p-t-sm" style="height:5rem;" />
          </router-link>
        </div>
        <div class="g-tile-bottom has-text-primary has-background-black is-size-5">
          <div class="has-text-left p-t-sm">
            <div class="g-tile-top-sq has-background-primary"></div>
            <p class="m-t-sm p-none m-b-none is-size-5 m-l-none">{{ game.name.toUpperCase() }}</p>
            <p class="m-none p-none is-size-6">
              <span :class="game.score > 0.5 ? 'has-text-primary' : 'has-text-grey'">&#9733; </span>
              <span :class="game.score > 1.5 ? 'has-text-primary' : 'has-text-grey'">&#9733; </span>
              <span :class="game.score > 2.5 ? 'has-text-primary' : 'has-text-grey'">&#9733; </span>
              <span :class="game.score > 3.5 ? 'has-text-primary' : 'has-text-grey'">&#9733; </span>
              <span :class="game.score > 4.5 ? 'has-text-primary' : 'has-text-grey'">&#9733; </span>
              ({{ game.votes }})
            </p>
          </div>
        </div>
        <img :src="game.icon" style="width:100%;">
      </div>
      <p class="is-size-5 has-text-primary">Zahrajte si nejlepší akční , dobrodružství, pexeso hry, vyřešte kvízy a mnohem více! Užijte si to naplno!</p>
        <div class="m-b-md m-t-md">
          <a :href="smsLink" class="button is-primary has-text-black is-size-3 m-md" style="width:80%">Pošlete ANO na 90303</a>
        </div>
      </div>
    </div>
    <Footer class="is-uppercase has-text-weight-bold" />
  </div>
</template>

<script>
import Footer from '@/components/LangKyf/Footer'

export default {
  name: 'Home',
  components: {
    Footer
  },
  data () {
    return {
      smsLink: `sms:90303${ navigator.userAgent.includes("Mac") && "ontouchend" in document ? '&' : '?' }body=ANO`,
      game: {
        name: 'Furious Red Riding Hood',
        path: 'https://assets.gamega.me/cn/fndxhm/index.html',
        icon: 'https://assets.gamega.me/cn/fndxhm/sqricon.jpg',
        tags: [ 'Adventure', 'Plataform' ],
        votes: 19,
        score: 4.736842105263158,
        id: 1
      }
    }
  },
  computed: {
    hasValidMsisdn () {
      return this.msisdn.split(' ').join('').match(/^(00386|0|\+386|386)?([1-9][0-9]+)/) instanceof Array
    }
  }
}
</script>


<style>
.g-tile {
  position: relative;
}
.g-tile-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4.2rem;
}
.g-tile-top-sq {
  margin: 0.8rem 1rem;
  height: 2.5rem;
  width: 2.5rem;
  float: left;
}
.g-tile-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/LangKyf/BG/Wait.vue